var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPath20(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.217,
    height: 33.052,
    viewBox: "0 0 47.217 33.052",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M47.217,14.967A10.361,10.361,0,0,0,36.856,4.606h-26.5A10.361,10.361,0,0,0,0,14.967V27.3A10.361,10.361,0,0,0,10.359,37.658h26.5A10.361,10.361,0,0,0,47.217,27.3ZM31.635,22.055l-11.88,5.879c-.466.249-2.049-.086-2.049-.617V15.251c0-.537,1.6-.872,2.06-.607l11.372,6.19c.478.27.981.961.5,1.222",
    transform: "translate(0 -4.606)",
    fill: "#121f55"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath20);
export default __webpack_public_path__ + "static/media/Path 20.b1e9f759e0cb2af83a1ab6c9d5678a5c.svg";
export { ForwardRef as ReactComponent };